import { IDefaultLabelValue } from '@/types/label-value.type'
import { ValueOf } from '@/types/value-of.type'

export const CHART_TYPE = {
  LINE: 'line',
  BAR: 'column',
  HORIZON_BAR: 'bar',
  AREA: 'area',
  AREA_RANGE: 'arearange',
  CURVE: 'spline',
  PIE: 'pie',
  DONUT: 'donut',
  TABLE: 'table',
  SANKEY: 'sankey',
  SCATTER: 'scatter',
  COMMON: 'common',
}
export type CHART_TYPE = ValueOf<typeof CHART_TYPE>

export const CHART_TYPE_LIST: IDefaultLabelValue[] = [
  {
    label: 'Line',
    value: CHART_TYPE.LINE,
  },
  {
    label: 'Bar',
    value: CHART_TYPE.BAR,
  },
  {
    label: 'Horizon Bar',
    value: CHART_TYPE.HORIZON_BAR,
  },
  {
    label: 'Area',
    value: CHART_TYPE.AREA,
  },
  {
    label: 'Curve',
    value: CHART_TYPE.CURVE,
  },
  {
    label: 'Pie',
    value: CHART_TYPE.PIE,
  },
  {
    label: 'Table',
    value: CHART_TYPE.TABLE,
  },
]

export const INDIVIDUAL_CHART_TYPE_LIST: IDefaultLabelValue[] = [
  {
    label: 'Line',
    value: CHART_TYPE.LINE,
  },
  {
    label: 'Bar',
    value: CHART_TYPE.BAR,
  },
  {
    label: 'Area',
    value: CHART_TYPE.AREA,
  },
  {
    label: 'Curve',
    value: CHART_TYPE.CURVE,
  },
]

export const CHART_STACKING_TYPE = {
  NONE: '',
  NORMAL: 'normal',
  PERCENT: 'percent',
}
export type CHART_STACKING_TYPE = ValueOf<typeof CHART_STACKING_TYPE>

export const CHART_STACKING_TYPE_LIST: IDefaultLabelValue[] = [
  {
    label: 'None',
    value: CHART_STACKING_TYPE.NONE,
  },
  {
    label: 'Standard',
    value: CHART_STACKING_TYPE.NORMAL,
  },
  {
    label: '100%',
    value: CHART_STACKING_TYPE.PERCENT,
  },
]

export const YAXIS_POSITION = {
  LEFT: 0,
  RIGHT: 1,
}
export type YAXIS_POSITION = ValueOf<typeof YAXIS_POSITION>

export const YAXIS_TYPE = {
  LINEAR: 'linear',
  LOG: 'logarithmic',
}
export type YAXIS_TYPE = ValueOf<typeof YAXIS_TYPE>

export const XAXIS_TYPE = {
  DATETIME: 'datetime',
  CATEGORY: 'category',
}
export type XAXIS_TYPE = ValueOf<typeof XAXIS_TYPE>

export const VIEW_PERIOD_PICKER = {
  DEFAULT: [
    { value: '7_day', label: '7D' },
    { value: '1_month', label: '1M' },
    { value: '6_month', label: '6M' },
    { value: '1_year', label: '1Y' },
    { value: '1_ytd', label: 'YTD' },
    { value: '1_all', label: 'ALL' },
    { value: 'selector', leftIcon: 'bc-calendar' },
  ],
  // HALF_YEAR: [
  //   { value: '6_month', label: '6M' },
  //   { value: '1_year', label: '1Y' },
  //   { value: '1_all', label: 'ALL' },
  // ],
  // TABLE_WEEK: [
  //   { value: '1d', label: '1D' },
  //   { value: '7d', label: '7D' },
  // ],
  // TABLE_WEEK_ALL: [
  //   { value: '1d', label: '1D' },
  //   { value: '7d', label: '7D' },
  //   { value: 'all', label: 'ALL' },
  // ],
  // TABLE_WEEK_MONTH_EXCEPT_ONE_DAY: [
  //   { value: '7d', label: '7D' },
  //   { value: '30d', label: '30D' },
  // ],
  // TABLE_WEEK_MONTH: [
  //   { value: '1d', label: '1D' },
  //   { value: '7d', label: '7D' },
  //   { value: '30d', label: '30D' },
  // ],
  // TABLE_WEEK_MONTH_ALL: [
  //   { value: '1d', label: '1D' },
  //   { value: '7d', label: '7D' },
  //   { value: '30d', label: '30D' },
  //   { value: 'all', label: 'ALL' },
  // ],
  // TABLE_MONTH_ALL: [
  //   { value: '30d', label: '30D' },
  //   { value: 'all', label: 'ALL' },
  // ],
  // TABLE_HALF_YEAR: [
  //   { value: '7d', label: '7D' },
  //   { value: '30d', label: '30D' },
  //   { value: '180d', label: '180D' },
  //   { value: 'all', label: 'ALL' },
  // ],
  NONE: [],
}
export type VIEW_PERIOD_PICKER = ValueOf<typeof VIEW_PERIOD_PICKER>

export const VIEW_PERIOD = {
  '1_DAY': '1_day', // 차트
  '7_DAY': '7_day', // 차트
  '1_MONTH': '1_month', // 차트
  '6_MONTH': '6_month', // 차트
  '1_YTD': '1_ytd', // 차트
  '1_YEAR': '1_year', // 차트
  '1_ALL': '1_all', // 차트
  SELECTOR: 'selector', // 차트
  // '1D': '1d', // 테이블
  // '7D': '7d', // 테이블
  // '30D': '30d', // 테이블
  // '180D': '180d', // 테이블
  // ALL: 'all', // 테이블
  NONE: '',
}
export type VIEW_PERIOD = ValueOf<typeof VIEW_PERIOD>